import bsAccordion from './bsAccordion';

export default () => {
  bsAccordion();
};
